import { XMarkIcon } from '@heroicons/react/24/solid'
import PropTypes from 'prop-types'

/**
 * Molecule Component: SelectedTalentCard
 * Shows a selected talent with remove functionality
 */
const SelectedTalentCard = ({ talent, onRemove }) => {
  const displayName = talent.name || talent.email || String(talent.id)
  const truncatedName = displayName.length > 40 ? displayName.slice(0, 37) + '...' : displayName

  const getInitials = (name) => {
    return name
      .split(' ')
      .map((n) => n[0])
      .join('')
      .slice(0, 2)
      .toUpperCase()
  }

  return (
    <div className='flex w-52 items-center justify-between rounded-lg bg-gray-50 p-3'>
      <div className='flex items-center space-x-3'>
        <div className='flex h-8 w-8 items-center justify-center rounded bg-blue-500 text-xs font-medium text-white'>
          {getInitials(displayName)}
        </div>
        <div>
          <div className='text-sm font-medium text-gray-900' title={displayName}>
            {truncatedName}
          </div>
        </div>
      </div>
      <button
        onClick={() => onRemove(talent)}
        className='text-gray-400 hover:text-gray-600'
      >
        <XMarkIcon className='h-4 w-4' />
      </button>
    </div>
  )
}

SelectedTalentCard.propTypes = {
  talent: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    name: PropTypes.string,
    email: PropTypes.string
  }).isRequired,
  onRemove: PropTypes.func.isRequired
}

export default SelectedTalentCard
